module.exports = __webpack_public_path__ + "img/activesuite9.6bd60bcf.jpg";